import { LayoutDashboard, type LucideIcon } from "lucide-react";
import { DashboardPageHeader } from "@/shared/ui/DashboardPageHeader";

type PageHeaderProps = {
  title: string;
  description?: string;
  icon?: LucideIcon;
};

export function PageHeader({ title, description, icon = LayoutDashboard }: PageHeaderProps) {
  return (
    <DashboardPageHeader
      title={title}
      subtitle={description}
      icon={icon}
    />
  );
}
